import { useTranslation } from "react-i18next";
import settings from "@/settings.json";
import { Button } from "@/components/ui/button";
import { CopyIcon, CheckIcon } from "lucide-react";
import { useState } from "react";
import { showSuccess } from "@/lib/toast";
import { cn } from "@/lib/utils";

export const PlayerKioskInstructions = () => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const kioskCommand = `"C:\\Program Files\\Google\\Chrome\\Application\\chrome.exe" --kiosk --disable-pinch --overscroll-history-navigation=0 --disable-features=TranslateUI ${settings.WeblinkDomain}/ds`;

  const handleCopy = () => {
    navigator.clipboard.writeText(kioskCommand);
    setCopied(true);
    showSuccess(t("common.copied"));
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <p>{t("settings.kioskInstructionsDescription")}</p>
      <div className="relative">
        <code className="block p-2 bg-muted rounded">
          "C:\Program Files\Google\Chrome\Application\chrome.exe" --kiosk --disable-pinch
          --overscroll-history-navigation=0 --disable-features=TranslateUI {settings.WeblinkDomain}/ds
        </code>
        <Button
          variant="outline"
          size="icon"
          onClick={handleCopy}
          className={cn("absolute top-2 right-2", copied && "text-green-500 border-green-500")}
          title={t("common.copy")}
        >
          {copied ? <CheckIcon className="h-4 w-4" /> : <CopyIcon className="h-4 w-4" />}
        </Button>
      </div>
      <p className="text-sm text-muted-foreground">{t("settings.kioskInstructionsNote")}</p>
    </>
  );
};
